module.exports = __webpack_public_path__ + "media/images/common/order_btn_s_ov-945cfdebf2b1dd48cb525d0fead88e8d.png";